import { render, staticRenderFns } from "./KeywordSuggestions.vue?vue&type=template&id=988f8bb4&"
import script from "./KeywordSuggestions.vue?vue&type=script&lang=js&"
export * from "./KeywordSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports